import { Icon } from "@iconify/react";
import {
  Button,
  Card,
  Flex,
  Grid,
  Input,
  message,
  Pagination,
  Table,
  Tag,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import useTitleStore from "../../store/titleStore";
import { useTableHeight } from "../../hooks/useTableHeight";
import useDebounce from "../../hooks/useDebounce";
import UpdatedByCell from "../../components/UpdatedByCell";
import { vocationalInstitutionService } from "../../services/vocationalInstitution.service";

export default function VocationalInstituteIndex() {
  const breakpoint = Grid.useBreakpoint();

  const navigate = useNavigate();
  const { setTitle } = useTitleStore();
  const tableHeight = useTableHeight();

  const [messageApi, contextHolder] = message.useMessage();
  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 500);
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    keyword: null,
  });

  const {
    data: instituteData,
    isLoading,
    isRefetching,
  } = useQuery({
    queryKey: ["vocational-institution", dataParams],
    queryFn: () => vocationalInstitutionService.fetchAll(dataParams),
    placeholderData: keepPreviousData,
  });

  useEffect(() => {
    setTitle("Lembaga Vokasi");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataParams((prev) => ({
      ...prev,
      keyword: debouncedKeyword,
    }));
  }, [debouncedKeyword]);

  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page,
    });
  };

  const columns = [
    {
      title: "No",
      align: "center",
      width: 50,
      render: (text, record, index) =>
        (instituteData?.pagination.page - 1) * dataParams.limit + index + 1,
      fixed: breakpoint.md && "left",
    },
    // {
    //   title: "ID Lembaga",
    //   dataIndex: "institutionId",
    //   width: 130,
    //   fixed: breakpoint.md && "left",
    // },
    {
      title: "Nama Lembaga",
      dataIndex: "name",
      width: 150,
      render: (val) => (
        <Typography.Text style={{ fontWeight: 600 }}>{val}</Typography.Text>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 100,
      render: (val) => (
        <Typography.Text
          style={{
            color: val === "Negeri" ? "green" : "blue",
          }}
        >
          {val}
        </Typography.Text>
      ),
    },
    {
      title: "Jenis Lembaga",
      dataIndex: "type",
      width: 140,
    },
    {
      title: "Bentuk Lembaga",
      dataIndex: "institutionForm",
      width: 150,
    },
    {
      title: "Provinsi",
      dataIndex: "province",
      width: 160,
    },
    {
      title: "Status Aktif",
      dataIndex: "isActive",
      width: 100,
      render: (val) => (
        <Tag color={val === true ? "green" : "red"}>
          {val === true ? "Aktif" : "Inaktif"}
        </Tag>
      ),
    },
    {
      title: "Update By",
      width: 150,
      render: (record) => <UpdatedByCell value={record} />,
    },
    {
      className: "last-cell-p",
      title: "Aksi",
      align: "right",
      width: 80,
      fixed: "right",
      render: (record) => (
        <Button
          icon={<Icon icon="solar:eye-bold-duotone" width="18" height="18" />}
          color="default"
          variant="filled"
          onClick={() =>
            navigate(`/vocational-institution/detail/${record.uuid}`)
          }
        />
      ),
    },
  ];

  return (
    <Card
      styles={{
        body: {
          paddingLeft: 0,
          paddingRight: 0,
        },
      }}
    >
      {contextHolder}
      <Flex
        justify="space-between"
        gap={20}
        style={{ paddingInline: 24, marginBottom: 24 }}
      >
        <Input
          style={{ width: 320 }}
          prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
          placeholder="Cari"
          onChange={(e) => setKeyword(e.target.value)}
          value={keyword}
        />
        <Button
          variant="solid"
          color="primary"
          icon={<Icon icon="duo-icons:add-circle" width="22" height="22" />}
          onClick={() => navigate("/vocational-institution/create")}
          style={{ minWidth: 38 }}
        >
          {breakpoint.md && "Tambah Lembaga Vokasi"}
        </Button>
      </Flex>
      <Table
        columns={columns}
        pagination={false}
        size="small"
        loading={isLoading || isRefetching}
        rowKey={"id"}
        scroll={{ y: tableHeight, x: 1200 }}
        dataSource={instituteData?.data}
      />
      <Pagination
        style={{ marginInline: 24, marginTop: 16 }}
        total={instituteData?.pagination.total}
        showSizeChanger={{
          showSearch: false,
        }}
        pageSizeOptions={["10", "20", "50"]}
        current={instituteData?.pagination.page}
        pageSize={dataParams.limit}
        align="end"
        onChange={handleChangePage}
      />
    </Card>
  );
}
